module.exports = "/images/webflow.png?2f55f655637c65e59a64b8cbfa9b1b1a";